import React, { useContext, useEffect, useState } from "react";
import Vehiclepagecard from "../../components/Cards/Vehiclepagecard";
import layer from "../../assets/images/Layer_1.svg";
import framevehicle from "../../assets/images/Framevehicle.svg";
import Group from "../../assets/images/Group.svg";
import Header from "../../components/Header/Header";
import VehiclePagecard2 from "../../components/Cards/VehiclePagecard2";
import BarChart from "../../components/Graphs/BarGraph/Vehiclepagegraph";
import ColorCardsVehicle from "../../components/Cards/ColorCardsVehicle";
import Filteraccordion from "../../components/accordion/Filteraccordian2";
import { FilterContext } from "../../context/Filter";
import WorldMap from "../../components/Maps/Vehiclemap";
import TableComponent from "../../components/Table/Vehicletable";
import TableComponent2 from "../../components/Table/Vehicletable2";
import DealerTable from "../../components/Table/VehicleTable3";
import Detailedview from "./Detailedview";
import Sparecardtb from "../../components/Cards/sparecardfortable";
import Filter from "../../components/Filter/VehicleFilter";
import {
  avgKmTable,
  avgKmWiseVehicle,
  firstPurchaseDate,
  lastPurchaseDate,
  productLineWiseBoxes,
  stateGraphData,
  stateVehicleCountData,
  getTotalVehicle,
} from "./VechicleKpi";
import VehiclePagecard4 from "../../components/Cards/VehiclePagecard4";
import Vehicletb from "../../components/Cards/Vehiclecardfortable";
import NavButtons from "../../components/NevBar/NavButtons";
import WaterMark from "../../components/WaterMark";

const Vehicle = () => {
  const {
    arn: parArn,
    arn,
    childArn,
    vehiclePayload,
    isvOpen,
    setIsvOpen,
    isFilterReady,
  } = useContext(FilterContext);
  const shouldEnableQuery = Boolean(parArn || childArn);
  const [loading, setLoading] = useState(true);
  const [firstPurchaseDateData, setFirstPurchaseDateData] = useState(null);
  const [totalVehicle, setTotalVehicle] = useState(null);
  const [lastPurchaseDateData, setLastPurchaseDateData] = useState(null);
  const { open } = useContext(FilterContext); // true = sidebar open
  const [stateGraphDataData, setStateGraphDataData] = useState(null);
  const [stateVehicleCountDatavalues, setStateVehicleCountDatavalues] =
    useState(null);
  const [avgKmWiseVehicleData, setAvgKmWiseVehicleData] = useState(null);
  const [avgKmTableData, setAvgKmTableData] = useState(null);
  const [productLineWiseBoxesData, setProductLineWiseBoxesData] =
    useState(null);
  const { search_type, dropDownValue, ...sanitizedPayload } =
    vehiclePayload || {};
  const refetchAllVehicleData = async () => {
    if (!shouldEnableQuery) return;
    setLoading(true);
    try {
      const [
        totalVehicleResp,
        firstPurchase,
        lastPurchase,
        stateGraph,
        stateVehicleCount,
        avgKmWise,
        avgKmTableResp,
        productLineWise,
      ] = await Promise.all([
        getTotalVehicle(parArn, childArn, sanitizedPayload),
        firstPurchaseDate(parArn, childArn, sanitizedPayload),
        lastPurchaseDate(parArn, childArn, sanitizedPayload),
        // totalvehicle(arn, childArn, sanitizedPayload),
        stateGraphData(parArn, childArn, sanitizedPayload),
        stateVehicleCountData(parArn, childArn, sanitizedPayload),
        avgKmWiseVehicle(parArn, childArn, sanitizedPayload),
        avgKmTable(parArn, childArn, sanitizedPayload),
        productLineWiseBoxes(parArn, childArn, sanitizedPayload),
      ]);

      setTotalVehicle(totalVehicleResp || {});
      setFirstPurchaseDateData(firstPurchase || {});
      setLastPurchaseDateData(lastPurchase || {});
      setStateGraphDataData(stateGraph || {});
      setStateVehicleCountDatavalues(stateVehicleCount || {});
      setAvgKmWiseVehicleData(avgKmWise || {});
      setAvgKmTableData(avgKmTableResp || {});
      setProductLineWiseBoxesData(productLineWise || {});
      // setTotalveh(totalvehiclee);
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isFilterReady) return;
    refetchAllVehicleData();
  }, [isFilterReady, parArn, childArn, vehiclePayload]);

  if (!isFilterReady || loading) {
    return (
      <div className="block md:flex justify-center items-center ">
        <div className="text-xl font-semibold">Loading vehicle data...</div>
      </div>
    );
  }

  return (
    <div>
      <WaterMark />
      <Header heading={"Vehicle"} />
      {isvOpen && (
        <div className="">
          <Filter />
        </div>
      )}
      <div className=" justify-items-center w-96 md:w-full block md:flex mt-1  mb-1  bg-white ">
        <Vehiclepagecard
          heading={"Total Vehicle"}
          value={totalVehicle?.doc_count}
          // des={"5.2% from last year"}
          logo={Group}
        />
        <Vehiclepagecard
          heading={"First Purchase Date"}
          value={firstPurchaseDateData?.result ?? "N/A"}
          logo={framevehicle}
        />


        <Vehiclepagecard
          heading={"Last Purchase Date"}
          value={lastPurchaseDateData?.result ?? "0"}
          logo={layer}
        />

        <Vehiclepagecard
          heading={"Avg Vehicle Age"}
          value={"10+ years"}
          logo={layer}
        />
        <div className="bg-[#087FC3]  p-2 rounded-md h-11 font-semibold mt-5 items-center justify-items-center">
          <Filteraccordion />
        </div>
      </div>
      <div className={`block  md:grid grid-cols-2 gap-1 `}>
        <div
          className={`border justify-items-center rounded m-1 transition-all duration-300 
            } `}
        >
          <VehiclePagecard4
            heading={"State-Wise Distribution"}
            des={<WorldMap data={stateGraphDataData} />}
          />
        </div>
        <div
          className={` justify-items-center p-1 md-p-0 rounded m-1 transition-all duration-300 
            } `}
        >
          <VehiclePagecard4
            heading={"Vehicle Count"}
            des={<BarChart data={avgKmWiseVehicleData} />}
            vcards={<ColorCardsVehicle data={productLineWiseBoxesData} />}
          />
        </div>
      </div>
      <div className="block ml-4 md:ml-0 w-96 md:w-full md:grid grid-cols-2 gap-1 mt-1 m-1 ">
        <div className="">
          <Vehicletb
            heading={"State-Wise Distribution"}
            des={<TableComponent data={stateVehicleCountDatavalues} />}
          />
        </div>
        <div className=" p-1 md:p-0">
          <Vehicletb
            heading={"Vehicle Count"}
            des={<TableComponent2 data={avgKmTableData} />}
          />
        </div>
      </div>
      <div className={`  ml-4 md:ml-3 w-96 md:max-w-[1200px] md:w-full `}>
        <Detailedview />
      </div>
      <NavButtons />
    </div>
  );
};

export default Vehicle;
